var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfqUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_16758_6333",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.334 0H5.665C2.26743 0 0 2.4326 0 5.916V14.084C0 17.5707 2.26137 20 5.665 20H14.333C17.7376 20 20 17.5707 20 14.084V5.916C20 2.4295 17.7378 0 14.334 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.334 -2H5.665V2H14.334V-2ZM5.665 -2C3.46858 -2 1.51111 -1.20206 0.10852 0.274109C-1.28504 1.74078 -2 3.73711 -2 5.916H2C2 4.61148 2.41875 3.64982 3.0083 3.02934C3.58882 2.41836 4.46384 2 5.665 2V-2ZM-2 5.916V14.084H2V5.916H-2ZM-2 14.084C-2 16.2627 -1.28767 18.2595 0.105994 19.7269C1.5089 21.2039 3.4671 22 5.665 22V18C4.45926 18 3.58497 17.5814 3.00628 16.9722C2.41835 16.3532 2 15.392 2 14.084H-2ZM5.665 22H14.333V18H5.665V22ZM14.333 22C16.5312 22 18.4898 21.204 19.8931 19.7271C21.2872 18.2599 22 16.2629 22 14.084H18C18 15.3917 17.5816 16.3528 16.9933 16.9719C16.4143 17.5813 15.5394 18 14.333 18V22ZM22 14.084V5.916H18V14.084H22ZM22 5.916C22 3.73716 21.2873 1.74032 19.8934 0.273066C18.4903 -1.20388 16.532 -2 14.334 -2V2C15.5398 2 16.4145 2.41863 16.9934 3.02806C17.5816 3.64718 18 4.60834 18 5.916H22Z",
    fill: "#52B3A7",
    mask: "url(#path-1-inside-1_16758_6333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqUncheck);
export default __webpack_public_path__ + "static/media/rfq-uncheck.f8909e736fd085f990a299f678aadb0b.svg";
export { ForwardRef as ReactComponent };